import React from "react";
import { ReactComponent as Checkmark } from "../../../../../assets/images/check-black.svg";
import { Button } from "../../../../../components";
import InfoCard from "./info-card";
import "./recommendations.css";

export interface EligibleRecommendationContent {
    title: string;
    cardTitle: string;
    cardDescription: string;
    sectionTitle: string;
    negativeResultTitle: string;
    negativeResultText: string;
    positiveResultTitle: string;
    positiveResultText: string;
    inconclusiveResultTitle: string;
    inconclusiveResultText: string;
    ctaLabel: string;
}

interface EligibleRecommendationLayoutProps {
    content: EligibleRecommendationContent;
    onSubmit: () => void;
    disabled?: boolean;
    loading?: boolean;
}

export default function EligibleRecommendationLayout({
    content,
    onSubmit,
    disabled = false,
    loading = false,
}: EligibleRecommendationLayoutProps): React.ReactElement {
    return (
        <section className="hpv-recommendations__layout">
            <h2 className="hpv-recommendations__heading">{content.title}</h2>

            <InfoCard Icon={Checkmark} title={content.cardTitle}>
                {content.cardDescription}
            </InfoCard>

            <div className="hpv-recommendations__body">
                <h3 className="hpv-recommendations__title">
                    {content.sectionTitle}
                </h3>
                <ul className="hpv-recommendations__list">
                    <li className="hpv-recommendations__list-item">
                        <strong>{content.negativeResultTitle}</strong>
                        {content.negativeResultText}
                    </li>
                    <li className="hpv-recommendations__list-item">
                        <strong>{content.positiveResultTitle}</strong>
                        {content.positiveResultText}
                    </li>
                    <li className="hpv-recommendations__list-item">
                        <strong>{content.inconclusiveResultTitle}</strong>
                        {content.inconclusiveResultText}
                    </li>
                </ul>
            </div>

            <Button
                className="hpv-recommendations__button"
                onClick={onSubmit}
                disabled={disabled}
                loading={loading}
            >
                {content.ctaLabel}
            </Button>
        </section>
    );
}
